import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./heading-capability.css";
import { useLanguage } from "../../i18n/LanguageContext";

gsap.registerPlugin(ScrollTrigger);

export default function HeadingCapability() {
  const rootRef = useRef(null);
  const { tr } = useLanguage();

  useEffect(() => {
    const ctx = gsap.context(() => {
      const root = rootRef.current;
      if (!root) return;

      const isMobile = window.innerWidth <= 768;

      // Refresh ScrollTrigger saat resize
      const handleResize = () => {
        ScrollTrigger.refresh();
      };
      window.addEventListener("resize", handleResize);

      // === FADE SCROLL HINT (INTRO) ===
      // Adapted from provided logic
      gsap.to(".hc-scroll", {
        autoAlpha: 0,
        duration: 0.2,
        scrollTrigger: {
          trigger: document.body,
          start: "top top",
          end: "top top-=1",
          toggleActions: "play none reverse none",
        },
      });

      // === LETTER SCROLL ANIMATION ===
      // Adapted from provided logic
      const hcList = root.querySelector(".hc-list");
      if (hcList) {
      gsap.to(".hc-letter", {
        yPercent: 100,
          ease: "power1.inOut",
        scrollTrigger: {
            trigger: hcList,
            start: "33.33% bottom",
            end: "100% 80%",
            scrub: 1,
        },
        stagger: {
            each: 0.05,
            from: "random",
          },
        });
      }

      // === SLIDE PPT STYLE (like capability.jsx) ===
      // Set initial state
      gsap.set(root, { autoAlpha: 1, y: 0 });

      if (hcList) {
        gsap.set(hcList, { opacity: 1, y: 0 });
      }

      // Mobile: Skip pinning and complex fade animations
      if (isMobile) {
        console.log("HP")
        const slideHeight = window.innerHeight;

        // Pin section for full viewport height (like PowerPoint)
        ScrollTrigger.create({
          trigger: root,
          start: "top top",
          end: `+=${slideHeight}`,
          pin: root,
          pinSpacing: true,
          scrub: false,

        });


        // Simple fade in for mobile
        if (hcList) {
          gsap.fromTo(
            hcList,
            { opacity: 0, y: 20 },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
              scrollTrigger: {
                trigger: root,
                start: "top 85%",
                end: "top 50%",
                scrub: true,
                invalidateOnRefresh: true,
              },
            }
          );
        }
      } else {
        console.log("Laptop")
        // Desktop: Full pinning and fade animations
      const slideHeight = window.innerHeight;

      // Pin section for full viewport height (like PowerPoint)
      ScrollTrigger.create({
        trigger: root,
        start: "top top",
        end: `+=${slideHeight}`,
        pin: root,
        pinSpacing: true,
        scrub: false,

      });

      // Fade in animation when section enters viewport (support scroll up)
        // Only fade content, not background
        if (hcList) {
      gsap.fromTo(
            hcList,
            { opacity: 0, y: 30 },
        {
              opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: root,
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            invalidateOnRefresh: true,
          },
        }
      );
        }

      // Fade out animation when section exits (support scroll up)
        // Only fade content, keep background visible to prevent black screen
        if (hcList) {
          gsap.fromTo(
                hcList,
                { opacity: 1, y: 0 },
            {
              opacity: 0,
              y: -30,
              duration: 1,
              ease: "power2.in",
              scrollTrigger: {
                trigger: root,
                start: "bottom top",
                end: `bottom+=${slideHeight * 0.5} top`,
                scrub: true,
                invalidateOnRefresh: true,
              },
            }
          );
        }
      }

      // Refresh setelah setup
      ScrollTrigger.refresh();

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, rootRef);

    return () => ctx.revert();
  }, []);

  return (
    <div style={{ backgroundColor: "#D8D8D8" }}>
      <section id="solutions" className="heading-capability" ref={rootRef}>
        

        <ul className="hc-list">
          <li>
            {tr("Metagent", "Metagent").split("").map((char, i) => (
              <span key={i} className="hc-letter">
                <span>{char}</span>
                <span>{char}</span>
              </span>
            ))}
          </li>

          <li>
            {tr("is Your", "adalah").split("").map((char, i) => 
              char === " " ? (
                <span key={i} className="hc-space"> </span>
              ) : (
                <span key={i} className="hc-letter">
                  <span>{char}</span>
                  <span>{char}</span>
                </span>
              )
            )}
          </li>

          <li>
            {tr("Solution", "Solusi").split("").map((char, i) => (
              <span key={i} className="hc-letter">
                <span>{char}</span>
                <span>{char}</span>
              </span>
            ))}
          </li>
        </ul>
      </section>
    </div>

  );
}
